import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const Item = styled.div`
  flex-shrink: 0;

  ${({ theme }) => `
    margin-right: ${theme.space.mobile.tiny};
    margin-bottom: ${theme.space.mobile.tiny};
  `}

  ${({ theme }) => media.sm`
    margin-right: ${theme.space.desktop.tiny};
    margin-bottom: ${theme.space.desktop.tiny};
  `}
`
